import React from 'react'

const Onsale = () => {
  return (
    <div>Onsale</div>
  )
}

export default Onsale